import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { COLORS } from 'styleguide';

const CloseLink = styled(Link)`
  position: absolute;
  top: 2px;
  right: 0;
  outline: none;
  color: ${COLORS.gray60};
  transition: color 0.25s ease-out;

  &:hover {
    color: #fff;
  }
`;

export default CloseLink;
